module.exports = __webpack_public_path__ + "img/bottom-teeth.02f5188f.png";